import { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { Center, Loader } from "@mantine/core";

import { useAuth } from "@admin/hooks/use-auth";
import { getReturnPath } from "@admin/utils/auth-navigation";

interface GuestGuardProps {
	children: ReactNode;
}

export function GuestGuard({ children }: GuestGuardProps) {
	const { isAuthenticated, isInitialized, isCheckingAuth, isRefreshing } = useAuth();
	const { search } = useLocation();

	// Show loading state while checking authentication
	if (!isInitialized || isCheckingAuth || isRefreshing) {
		return (
			<Center style={{ height: "100vh" }}>
				<Loader size="lg" />
			</Center>
		);
	}

	// If user is authenticated, redirect to return path or dashboard
	if (isAuthenticated) {
		const redirectTo = getReturnPath(search);
		return <Navigate to={redirectTo} replace />;
	}

	// Otherwise, render children (login page)
	return <>{children}</>;
}
